/* src/app/shared/components/confirm-dialog/confirm-dialog.component.scss */
.dialog-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
.dialog-buttons button:not(:first-child) {
  margin-left: 40px;
}
.dialog-buttons .right-align-button {
  margin-left: auto;
  margin-right: 20px;
}
/*# sourceMappingURL=confirm-dialog.component.css.map */
